import type { Account, InventoryResource, Snapshot } from '@repo/api-gw-sdk';
import { Provider } from '@repo/api-gw-sdk';

import { FEATURES_SUPPORT_VERSIONS } from '@/configs/featureConfig';

import { GcpCloudSqlConfiguration } from './steps/gcp/gcpCloudSqlConfiguration';
import { SelectTargetAccountStep } from './steps/selectTargetAccount';

import type { Step } from '../wizard/Step';
import { Wizard } from '../wizard/Wizard';

export interface RestoreGcpCloudSqlState {
  resourceId: string;
  snapshot: Snapshot;
  resourceName: string;
  subnetName?: string;
  subnetId?: number;
  networkName?: string;
  networkHostProject?: string;
  isSharedNetwork?: boolean;
  zone?: string;
  supportedCloudProviders: Provider[];
  supportedInstalledVersion?: string;
  restoreAccount?: Account;
  regionName?: string;
  initialTags: Record<string, string>;
  keepOriginalTags: boolean;
  tags: Record<string, string>;
}

const restoreGcpCloudSqlFlow: Step<RestoreGcpCloudSqlState> = {
  name: 'SelectTargetAccountStep',
  Component: SelectTargetAccountStep,
  next: [
    {
      name: 'GcpCloudSqlConfiguration',
      Component: GcpCloudSqlConfiguration,
    },
  ],
};

export const RestoreGcpCloudSqlWizard = ({
  resource,
  snapshot,
  onClose,
  onBack,
}: {
  resource: InventoryResource;
  snapshot: Snapshot;
  onClose: () => void;
  onBack: () => void;
}) => {
  return (
    <Wizard<RestoreGcpCloudSqlState>
      onAbort={(origin) => (origin === 'back' ? onBack() : onClose())}
      onFinish={async () => true}
      flow={[restoreGcpCloudSqlFlow]}
      initialState={{
        snapshot,
        resourceId: resource.id,
        supportedCloudProviders: [Provider.Gcp],
        supportedInstalledVersion:
          FEATURES_SUPPORT_VERSIONS.GCP_RESTORE_ACCOUNT_RESTORE_ACCOUNT,
        keepOriginalTags: true,
        resourceName: `${
          snapshot.resource?.properties?.gcpCloudSql?.instanceId ?? ''
        }-restored`,
        initialTags: snapshot.resource?.tags || {},
        tags: snapshot.resource?.tags || {},
        regionName:
          snapshot.resource?.properties?.gcpCloudSql?.region || 'us-east1',
        zone: snapshot.resource?.properties?.gcpCloudSql?.zone,
      }}
      title={`Restore Cloud SQL`}
      stepperLabels={['Restore Account', 'Configuration']}
    />
  );
};
